import classNames from 'classnames'

import Icon from 'shared/components/Icon'
import Modal from 'shared/components/Modal'
import ErrorMessage from 'shared/components/ErrorMessage'

import { isMobile } from 'shared/responsive-helpers'
import { CardSection } from 'shared/components/CardSection'
import { RateCurrency } from 'shared/price-utilities'

import { AdditionalBenefits } from './AdditionalBenefits'
import bookingStyles from '../styles.module.scss'

const UpSellModal = ({
    onClose,
    rate,
    selectedUpsellOption,
    setSelectedUpSellOption,
    headerLabel,
    onConfirmClick,
    onCancelClick,
    onCancelButtonClickLabel,
    upSellOptions,
    upgradeBtnIsLoading,
    upgradeBtnError,
    onCancelBtnClickLoading,
}) => {
    const modalHeaderLabel = (
        <span>
            {headerLabel} <span className={bookingStyles.modalHeaderRateName}> {rate.rateName}</span>?
        </span>
    )

    const confirmButtonLabel = isMobile() ? (
        <T>booking.up.sell.modal.confirm.button.mobile.label</T>
    ) : (
        <T>booking.up.sell.modal.confirm.button.desktop.label</T>
    )

    const upgradeUpSellError = upgradeBtnIsLoading && upgradeBtnIsLoading instanceof Error

    return (
        <Modal
            header={modalHeaderLabel}
            size={isMobile() ? 'small' : 'large'}
            noHeaderPaddings
            onClose={onClose}
            className={bookingStyles.upSellModalContent}
            buttons={[
                {
                    label: onCancelButtonClickLabel,
                    onClick: () => onCancelClick(),
                    btnClassName: 'brand-button--outline',
                    loading: onCancelBtnClickLoading,
                },
                {
                    label: confirmButtonLabel,
                    onClick: () => onConfirmClick(),
                    disabled: !selectedUpsellOption,
                    loading: upgradeBtnIsLoading && !upgradeBtnError,
                },
            ]}>
            {upSellOptions.map((option, index) => (
                <CardSection
                    key={index}
                    activeSelected={option.upSellRateId === selectedUpsellOption?.upSellRateId}
                    notActive
                    className={classNames('px-3', 'py-3', 'mt-3', bookingStyles.cardSectionUpSell)}>
                    <div
                        onClick={e => {
                            e.preventDefault()
                            setSelectedUpSellOption(option)
                        }}
                        className={bookingStyles.upSellOptionWrap}>
                        <div className="d-flex justify-content-between">
                            <div className={classNames('d-flex ', bookingStyles.radioLabelWrap)}>
                                <label htmlFor={'upsellOption'} className={bookingStyles.radioLabel}>
                                    <input
                                        className={bookingStyles.radioInput}
                                        type="radio"
                                        value={selectedUpsellOption?.upSellRateId === option.upSellRateId}
                                        id={'upsellOption'}
                                    />
                                    <div className={classNames(bookingStyles.customRadio)}>
                                        <Icon
                                            type={
                                                selectedUpsellOption?.upSellRateId === option.upSellRateId
                                                    ? 'radiobutton-on'
                                                    : 'radiobutton-off'
                                            }
                                        />
                                    </div>
                                    <span className={bookingStyles.rateName}>{option.upSellRateName}</span>
                                </label>
                            </div>
                            <div>
                                <span className={bookingStyles.rateAmount}>
                                    + <RateCurrency rate={rate} value={option.additionalAmount} />
                                </span>
                            </div>
                        </div>
                        {option?.rateIcons?.length > 0 && (
                            <AdditionalBenefits
                                images={option?.rateIcons}
                                label={<T>booking.up.sell.modal.additional.benefits.label</T>}
                            />
                        )}
                    </div>
                </CardSection>
            ))}
            {upgradeUpSellError && selectedUpsellOption && (
                <ErrorMessage messages={[upgradeBtnError ? upgradeBtnError : <T>booking.error.rates.not.found</T>]} />
            )}
        </Modal>
    )
}

export default UpSellModal
